<script setup>
import config from '@/common/config'
import { qsel } from '@/common/util'
import NoticeAndTermsRoot from '@/components/member/NoticeAndTermsRoot.vue'
import { useMemberStore, useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { onMounted, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
const menus=reactive([{tks:['map'],icon:'map_normal.png',type:'member',link:'/member/map'}/*,{tks:['streetview','inquiries'],icon:'mdi-information-outline',type:'member',link:'/member/rvinquery'}*/
  ,{tks:['openapi'],icon:'mdi-api',type:'member',link:'/member/openapi'},{tks:['managedata'],icon:'managedata_normal.png',type:'adm',link:'/admin/mandata'}
  ,{tks:['manageusers'],icon:'manageusers_normal.png',type:'adm',link:'/admin/manmem'},{tks:['sysconf'],icon:'sysconf_normal.png',type:'adm',link:'/admin/sysconf'}
  ,{tks:['manserv'],icon:'manserv_normal.png',type:'adm',link:'/admin/manserv'}
  ,{tks:['more'],icon:'more_normal.png',type:'additional'},{tks:['mypage'],icon:'my_normal.png',type:'additional',link:'/member/mypage'}])
,memStore=useMemberStore(),metaStore=useMetaStore(),onpopnoticeterms=ref(false),inited=ref(false),route=useRoute()
,popNoticeAndTerms=flag=>{
  onpopnoticeterms.value=false
  metaStore.pop({ison:flag,callback:()=>onpopnoticeterms.value=flag})
}
function hoverToggle(dv){
  dv=dv.target
  let img=dv
  if(dv.tagName!='IMG')img=dv.querySelector('img')
  if(!img||img.src.includes('_selected'))return
  img.src=img.src.includes('_normal')?img.src.replace('_normal','_hover'):img.src.replace('_hover','_normal')
}
function menuSel(menu){
  if(route.path.includes(menu.link)){
    return menu._selectedSrc
  }
  return menu._normalSrc
}
function init(){
  const logoImg = new Image();
  logoImg.src = config.backend + 'logo';
  menus.forEach(menu=>{
    const base = config.frontRoot+'img/menu/'+menu.icon.split('_normal')[0]
    menu._normalSrc = base + '_normal.png'
    menu._hoverSrc = base + '_hover.png'
    menu._selectedSrc = base + '_selected.png'
    const normalimg = new Image();
    normalimg.src = menu._normalSrc;
    const hoverimg = new Image();
    hoverimg.src = menu._hoverSrc;
    const selectedimg = new Image();
    selectedimg.src = menu._selectedSrc;
  })
  if(metaStore.dispmode=='minimum'){
    _.remove(menus,item=>item.link=='/member/rvinquery')
    _.remove(menus,item=>item.link=='/member/openapi')
    _.remove(menus,item=>item.link=='/admin/sysconf')
  }
  _.remove(menus,item=>item.link=='/member/rvinquery')
  _.remove(menus,item=>item.link=='/member/openapi')
  inited.value=true
}
init()
</script>
<template>
  <div style="min-height: 900px;height: 100vh;display: flex;flex-direction: column;">
    <v-sheet v-if="inited" class="d-flex flex-nowrap ma-0 pa-0" style="flex: 1 0 auto;">
      <v-sheet class="lmb d-flex flex-column pa-0">
        <v-defaults-provider :defaults="{'VBtn':{'variant':'text','size':60,'class':'mt-0 w-100 pa-0 text-center','stacked':'true'}}">
          <div class="flex-1-1 d-flex flex-column">
            <div class="d-flex justify-center align-center cursor-pointer hover-toggle" style="height: 80px;" @click="$router.push(menus[0].link)">
              <img id="logo" :src="config.backend+'logo'"/>
            </div>
            <div style="width: 30px;margin: 0 auto;background-color: #EEEEEE;font-size: 1px;">&nbsp;</div>
            <div v-for="menu in menus.filter(m=>m.type=='member')" class="cursor-pointer" @mouseenter.self="hoverToggle" @mouseleave.self="hoverToggle" @click="$router.push(menu.link)">
              <div class="text-center" style="margin-top: 14px;">
                <img class="topbtns" v-for="src in ['_normalSrc','_hoverSrc','_selectedSrc']" v-show="menuSel(menu)==menu[src]" :src="menu[src]" />
              </div>
              <div class="text-center" :style="menu.selected?'font-weight:bold;color:#1573FF':''">{{ menu.tks.map($t).join('<br/>') }}</div>
            </div>
          </div>
          <div v-for="type in memStore.isAdm()?['adm','additional']:['additional']" :class="`flex-1-1 d-flex flex-column${type=='additional'?' flex-grow-1 flex-column-reverse':''}`">
            <div v-for="menu in menus.filter(m=>m.type==type)" class="cursor-pointer" @mouseenter.self="hoverToggle" @mouseleave.self="hoverToggle" @click="()=>{
              if(menu.tks[0]=='more')popNoticeAndTerms(true)
              else $router.push(menu.link)
              if(menu.tks[0]=='mypage'){
                const btntomypage=qsel('.btntomypage')
                if(btntomypage)btntomypage.click()
              }
            }">
              <div class="text-center" style="margin-top: 14px;">
                <img class="bottombtns" v-for="src in ['_normalSrc','_hoverSrc','_selectedSrc']" v-show="menuSel(menu)==menu[src]" :src="menu[src]" />
              </div>
              <div class="text-center" :style="menu.selected?'font-weight:bold;color:#1573FF':''">{{ menu.tks.map($t).join('<br/>') }}</div>
            </div>
          </div>
        </v-defaults-provider>
        <div>&nbsp;</div>
        <!--
          <LocalePicker v-if="metaStore.dispmode!='minimum'" style="margin-bottom: 5px;"/>
        -->
      </v-sheet>
      <v-sheet class="flex-grow-1 h-100 con">
        <slot/>
      </v-sheet>
    </v-sheet>
  </div>
  <Teleport v-if="onpopnoticeterms" to="#popbody">
    <NoticeAndTermsRoot @on-close="onpopnoticeterms=false;metaStore.pop({ison:false})"/>
  </Teleport>
</template>
<style scoped>
.lmb{min-width: 80px;font-size: 12px;}
.con{width: calc(100% - 80px);}
.lmb .v-btn{font-size: 12px;height: 72px !important;}
</style>
